import * as api from '../salesCallApi';
import {
    AddInfoSalesCall,
    ISalesCall,
    salesCallActionCreators,
    SalesCallActionKeys
    } from '..';
import { businessEntityActionCreators } from '../../businessEntity';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* addInfoSalesCallSaga(action: AddInfoSalesCall) {
  yield put(uiActionCreators.showSpinnerDialog());
  try {
    const response: IEntityWithMessages<ISalesCall> = yield call(api.addInfoCall, action.payload);

    if (!response.error && response.value) {
      yield put(salesCallActionCreators.processSalesCalls([response.value]));
      yield put(businessEntityActionCreators.addSalesCalls([response.value]));
      yield put(uiActionCreators.hideInfoCallDialog());
    }
    yield processMessages(response);
  } catch {
    //
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddInfoSalesCall() {
  yield takeEvery(SalesCallActionKeys.ADD_INFO_SALESCALL, addInfoSalesCallSaga);
}
